import { Component, Host, h, Prop } from '@stencil/core'

@Component({
  tag: 'bam-footer-navigation',
  styleUrl: 'bam-footer-navigation.scss',
  shadow: false
})
export class BamFooterNavigation {
  @Prop() gridClass: string

  render() {
    return (
      <Host class={`col ${this.gridClass}`}>
          <slot></slot>
      </Host>
    )
  }
}
